import ampConfig from './services/amp-config.js';
import assignmentService from './services/assignment-service.js';
import autosave from './services/autosave.js';
import classroomState from './services/classroom-state.js';
import clientState from './services/client-state.js';
import configService from './config.js';
import content from './services/content-delivery.js';
import contentAccess from './services/content-access.js';
import drm from './services/drm.js';
import feedback from './services/feedback.js';
import gradeSync from './services/grade-sync.js';
import iauStorage from './services/iau-storage.js';
import insights from './services/insights.js';
import lmsMappingService from './services/lms-mapping-service.js';
import notes from './services/notes.js';
import onboarding from './services/onboarding.js';
import portfolio from './services/portfolio-bff.js';
import resetSubmissions from './services/reset-submissions.js';
import retail from './services/retail.js';
import score from './services/score.js';
import sharedStorage from './services/shared-storage.js';
import slidesService from './services/slides-services.js';
import storage from './services/storage.js';
import studentVariant from './services/student-variant.js';
import submission from './services/submission.js';
import thirdPartySecrets from './services/third-party-secrets.js';
import utility from './utility/utility.js';
import workSummary from './services/work-summary.js';
import worksheet from './services/worksheet-service.js';
import object from './services/object-storage-service.js';
import customContentService from './services/custom-content.js';
import mathStorage from './services/math-storage.js';
import userCreatedInsights from './services/user-created-insights.js';
var fetchIntercomUserHash = thirdPartySecrets.fetchIntercomUserHash,
    fetchLearnositySignature = thirdPartySecrets.fetchLearnositySignature,
    fetchQuillHash = thirdPartySecrets.fetchQuillHash;
export { fetchIntercomUserHash, fetchLearnositySignature, fetchQuillHash };
var clearWork = portfolio.clearWork,
    fetchClassSummary = portfolio.fetchClassSummary,
    fetchUsersWithWork = portfolio.fetchUsersWithWork,
    fetchWorkSummary = portfolio.fetchWorkSummary;
export { clearWork, fetchClassSummary, fetchUsersWithWork, fetchWorkSummary };
var checkUnitKeysAreValid = content.checkUnitKeysAreValid,
    fetchCardstacksForUnit = content.fetchCardstacksForUnit,
    fetchOverview = content.fetchOverview,
    fetchUnit = content.fetchUnit,
    fetchUnitRevision = content.fetchUnitRevision,
    fetchUnitRevisionAliases = content.fetchUnitRevisionAliases;
export { checkUnitKeysAreValid, fetchCardstacksForUnit, fetchOverview, fetchUnit, fetchUnitRevision, fetchUnitRevisionAliases };
var fetchScores = score.fetchScores,
    fetchScoresForCardstacks = score.fetchScoresForCardstacks,
    saveScores = score.saveScores;
export { fetchScores, fetchScoresForCardstacks, saveScores };
var fetchMySubmissions = submission.fetchMySubmissions,
    fetchRecentSubmissions = submission.fetchRecentSubmissions,
    fetchSubmissionBreadcrumbs = submission.fetchSubmissionBreadcrumbs,
    fetchSubmissionForActivity = submission.fetchSubmissionForActivity,
    fetchSubmissions = submission.fetchSubmissions,
    forceSubmissions = submission.forceSubmissions,
    postSubmissions = submission.postSubmissions;
export { fetchMySubmissions, fetchRecentSubmissions, fetchSubmissionBreadcrumbs, fetchSubmissionForActivity, fetchSubmissions, forceSubmissions, postSubmissions };
var createComment = feedback.createComment,
    deleteComment = feedback.deleteComment,
    fetchAllCommentsInCardstack = feedback.fetchAllCommentsInCardstack,
    fetchAllManualScores = feedback.fetchAllManualScores,
    fetchAllUnreadFeedback = feedback.fetchAllUnreadFeedback,
    fetchLatestManualScore = feedback.fetchLatestManualScore,
    fetchManualScore = feedback.fetchManualScore,
    fetchRubricScores = feedback.fetchRubricScores,
    fetchUnsentFeedbackCountForCardstack = feedback.fetchUnsentFeedbackCountForCardstack,
    fetchUnsentFeedbackCountForClass = feedback.fetchUnsentFeedbackCountForClass,
    getSkills = feedback.getSkills,
    markAllCommentsAsRead = feedback.markAllCommentsAsRead,
    markAllFeedbackAsRead = feedback.markAllFeedbackAsRead,
    markAllManualScoresAsRead = feedback.markAllManualScoresAsRead,
    markCommentAsRead = feedback.markCommentAsRead,
    markManualScoreAsRead = feedback.markManualScoreAsRead,
    saveAllComments = feedback.saveAllComments,
    saveAllManualScores = feedback.saveAllManualScores,
    saveAllRubricScores = feedback.saveAllRubricScores,
    saveAndSendAllComments = feedback.saveAndSendAllComments,
    saveAndSendManualScore = feedback.saveAndSendManualScore,
    saveManualScore = feedback.saveManualScore,
    saveRubricScore = feedback.saveRubricScore,
    sendComments = feedback.sendComments,
    sendManualScore = feedback.sendManualScore,
    sendScoreAndComments = feedback.sendScoreAndComments,
    setAutoScoreVisibility = feedback.setAutoScoreVisibility,
    submitAllFeedbackForCardstack = feedback.submitAllFeedbackForCardstack,
    updateComment = feedback.updateComment;
export { createComment, deleteComment, fetchAllCommentsInCardstack, fetchAllManualScores, fetchAllUnreadFeedback, fetchLatestManualScore, fetchManualScore, fetchRubricScores, fetchUnsentFeedbackCountForCardstack, fetchUnsentFeedbackCountForClass, getSkills, markAllCommentsAsRead, markAllFeedbackAsRead, markAllManualScoresAsRead, markCommentAsRead, markManualScoreAsRead, saveAllComments, saveAllManualScores, saveAllRubricScores, saveAndSendAllComments, saveAndSendManualScore, saveManualScore, saveRubricScore, sendComments, sendManualScore, sendScoreAndComments, setAutoScoreVisibility, submitAllFeedbackForCardstack, updateComment };
var deleteSubmissionsAndAutosaves = resetSubmissions.deleteSubmissionsAndAutosaves;
export { deleteSubmissionsAndAutosaves };
var autosaveExists = autosave.autosaveExists,
    fetchAutosave = autosave.fetchAutosave,
    fetchAutosavesByPrefix = autosave.fetchAutosavesByPrefix,
    fetchBulkAutosaves = autosave.fetchBulkAutosaves,
    writeAutosave = autosave.writeAutosave;
export { autosaveExists, fetchAutosave, fetchAutosavesByPrefix, fetchBulkAutosaves, writeAutosave };
var fetchBulkWorkSummaryStatus = workSummary.fetchBulkWorkSummaryStatus,
    fetchWorkSummaryStatus = workSummary.fetchWorkSummaryStatus;
export { fetchBulkWorkSummaryStatus, fetchWorkSummaryStatus };
var deleteWorksheet = worksheet.deleteWorksheet,
    deleteWorksheets = worksheet.deleteWorksheets,
    fetchBulkWorksheets = worksheet.fetchBulkWorksheets,
    fetchWorksheet = worksheet.fetchWorksheet,
    writeWorksheet = worksheet.writeWorksheet;
export { deleteWorksheet, deleteWorksheets, fetchBulkWorksheets, fetchWorksheet, writeWorksheet };
var controllerEnum = clientState.controllerEnum,
    deleteClientState = clientState.deleteClientState,
    deleteGoogleDocId = clientState.deleteGoogleDocId,
    deleteOptInStatusForUser = clientState.deleteOptInStatusForUser,
    fetchAllClassroomSettingStates = clientState.fetchAllClassroomSettingStates,
    fetchAllStudentAudioAccessStates = clientState.fetchAllStudentAudioAccessStates,
    fetchClassContentState = clientState.fetchClassContentState,
    fetchClassroomSettingState = clientState.fetchClassroomSettingState,
    fetchClassworkState = clientState.fetchClassworkState,
    fetchClientState = clientState.fetchClientState,
    fetchCustomComments = clientState.fetchCustomComments,
    fetchGoogleDocId = clientState.fetchGoogleDocId,
    fetchLanguageState = clientState.fetchLanguageState,
    fetchLastLessonLocation = clientState.fetchLastLessonLocation,
    fetchLastLessonViewedLocation = clientState.fetchLastLessonViewedLocation,
    fetchOptInStatusForUser = clientState.fetchOptInStatusForUser,
    fetchSelectedCustomLesson = clientState.fetchSelectedCustomLesson,
    fetchClientStateFromStorage = clientState.fetchStateFromStorage,
    fetchStudentAudioAccessState = clientState.fetchStudentAudioAccessState,
    fetchStudentState = clientState.fetchStudentState,
    fetchUserFile = clientState.fetchUserFile,
    fetchViewedTutorials = clientState.fetchViewedTutorials,
    saveAllClassContentStates = clientState.saveAllClassContentStates,
    saveAllClassroomSettingStates = clientState.saveAllClassroomSettingStates,
    saveAllStudentAudioAccessStates = clientState.saveAllStudentAudioAccessStates,
    saveClassContentState = clientState.saveClassContentState,
    saveClassroomSettingState = clientState.saveClassroomSettingState,
    saveClassworkState = clientState.saveClassworkState,
    saveClientState = clientState.saveClientState,
    saveCustomComments = clientState.saveCustomComments,
    saveGoogleDocId = clientState.saveGoogleDocId,
    saveLanguageState = clientState.saveLanguageState,
    saveLastLessonViewedLocation = clientState.saveLastLessonViewedLocation,
    saveLastStartedClass = clientState.saveLastStartedClass,
    saveOptInStatusForUser = clientState.saveOptInStatusForUser,
    saveSelectedCustomLesson = clientState.saveSelectedCustomLesson,
    saveClientStateToStorage = clientState.saveStateToStorage,
    saveStudentAudioAccessState = clientState.saveStudentAudioAccessState,
    saveStudentState = clientState.saveStudentState,
    saveUserFile = clientState.saveUserFile,
    saveViewedTutorials = clientState.saveViewedTutorials,
    fetchClientStateBatch = clientState.fetchClientStateBatch;
export { controllerEnum, deleteClientState, deleteGoogleDocId, deleteOptInStatusForUser, fetchAllClassroomSettingStates, fetchAllStudentAudioAccessStates, fetchClassContentState, fetchClassroomSettingState, fetchClassworkState, fetchClientState, fetchCustomComments, fetchGoogleDocId, fetchLanguageState, fetchLastLessonLocation, fetchLastLessonViewedLocation, fetchOptInStatusForUser, fetchSelectedCustomLesson, fetchClientStateFromStorage, fetchStudentAudioAccessState, fetchStudentState, fetchUserFile, fetchViewedTutorials, saveAllClassContentStates, saveAllClassroomSettingStates, saveAllStudentAudioAccessStates, saveClassContentState, saveClassroomSettingState, saveClassworkState, saveClientState, saveCustomComments, saveGoogleDocId, saveLanguageState, saveLastLessonViewedLocation, saveLastStartedClass, saveOptInStatusForUser, saveSelectedCustomLesson, saveClientStateToStorage, saveStudentAudioAccessState, saveStudentState, saveUserFile, saveViewedTutorials, fetchClientStateBatch };
var getRosterAccessState = contentAccess.getRosterAccessState,
    getStates = contentAccess.getStates,
    getStudentAccessState = contentAccess.getStudentAccessState,
    lockStudent = contentAccess.lockStudent,
    lockStudentAudio = contentAccess.lockStudentAudio,
    unlockStudent = contentAccess.unlockStudent,
    unlockStudentAudio = contentAccess.unlockStudentAudio;
export { getRosterAccessState, getStates, getStudentAccessState, lockStudent, lockStudentAudio, unlockStudent, unlockStudentAudio };
var fetchStudentVariants = studentVariant.fetchStudentVariants,
    fetchStudentVariantsBatch = studentVariant.fetchStudentVariantsBatch,
    saveStudentVariants = studentVariant.saveStudentVariants;
export { fetchStudentVariants, fetchStudentVariantsBatch, saveStudentVariants };
export var fetchAmpConfig = ampConfig.fetchAmpConfig.bind(ampConfig);
var fetchClass = onboarding.fetchClass,
    fetchClassRoster = onboarding.fetchClassRoster,
    fetchUser = onboarding.fetchUser,
    fetchUserClasses = onboarding.fetchUserClasses,
    setUniqueDisplayNames = onboarding.setUniqueDisplayNames;
export { fetchClass, fetchClassRoster, fetchUser, fetchUserClasses, setUniqueDisplayNames };
var filterActiveStudents = utility.filterActiveStudents,
    onlyClasses = utility.onlyClasses,
    sortStudents = utility.sortStudents;
export { filterActiveStudents, onlyClasses, sortStudents };
var acquireDrmBookLicense = drm.acquireBookLicense,
    fetchDrmBookChecksum = drm.fetchBookChecksum,
    fetchDrmBookComponent = drm.fetchBookComponent,
    fetchDrmBookDetails = drm.fetchBookDetails,
    fetchDrmBookResource = drm.fetchBookResource,
    fetchDrmBooks = drm.fetchBooks,
    fetchDrmChecksum = drm.fetchChecksum,
    fetchDrmDeviceUpdates = drm.fetchDeviceUpdates,
    fetchDrmAssessmentActivityAudio = drm.fetchDrmAssessmentActivityAudio,
    fetchDrmAssessmentActivityMarks = drm.fetchDrmAssessmentActivityMarks,
    fetchDrmGlobalKey = drm.fetchGlobalKey,
    fetchDrmPublicKey = drm.fetchPublicKey,
    fetchDrmSettings = drm.fetchSettings,
    fetchDrmUserKey = drm.fetchUserKey,
    pingDrm = drm.ping,
    revokeDrmBookLicense = drm.revokeBookLicense,
    searchDrmBook = drm.searchBook;
export { acquireDrmBookLicense, fetchDrmBookChecksum, fetchDrmBookComponent, fetchDrmBookDetails, fetchDrmBookResource, fetchDrmBooks, fetchDrmChecksum, fetchDrmDeviceUpdates, fetchDrmAssessmentActivityAudio, fetchDrmAssessmentActivityMarks, fetchDrmGlobalKey, fetchDrmPublicKey, fetchDrmSettings, fetchDrmUserKey, pingDrm, revokeDrmBookLicense, searchDrmBook };
var fetchAllMyClassAssets = retail.fetchAllMyClassAssets,
    fetchAllMyClassesWithPrograms = retail.fetchAllMyClassesWithPrograms,
    fetchAllMyStudentsAssets = retail.fetchAllMyStudentsAssets,
    fetchEntitlementsFromClasses = retail.fetchEntitlementsFromClasses,
    fetchProgramData = retail.fetchProgramData,
    fetchProgramDataWithHeaders = retail.fetchProgramDataWithHeaders,
    fetchUserAssets = retail.fetchUserAssets;
export { fetchAllMyClassAssets, fetchAllMyClassesWithPrograms, fetchAllMyStudentsAssets, fetchEntitlementsFromClasses, fetchProgramData, fetchProgramDataWithHeaders, fetchUserAssets };
var createInsights = insights.createInsights,
    fetchAllInsights = insights.fetchAllInsights,
    fetchInsight = insights.fetchInsight,
    updateInsight = insights.updateInsight,
    updateInsightStudent = insights.updateInsightStudent;
export { createInsights, fetchAllInsights, fetchInsight, updateInsight, updateInsightStudent };
var createOrUpdateInsight = userCreatedInsights.createOrUpdateInsight,
    dismissInsight = userCreatedInsights.dismissInsight,
    findInsight = userCreatedInsights.findInsight;
export { createOrUpdateInsight, dismissInsight, findInsight };
var batchFetchClassroomState = classroomState.batchFetchClassroomState,
    batchSaveClassroomState = classroomState.batchSaveClassroomState,
    deleteAllClassroomStateWithPrefix = classroomState.deleteAllClassroomStateWithPrefix,
    fetchClassroomState = classroomState.fetchClassroomState,
    fetchClassroomStateWithPrefix = classroomState.fetchClassroomStateWithPrefix,
    saveClassroomState = classroomState.saveClassroomState;
export { batchFetchClassroomState, batchSaveClassroomState, deleteAllClassroomStateWithPrefix, fetchClassroomState, fetchClassroomStateWithPrefix, saveClassroomState };
export var config = {
  set: configService.set,
  get: configService.get
};
var fetchBinary = iauStorage.fetchBinary,
    fetchImageData = iauStorage.fetchBinary,
    writeBinary = iauStorage.writeBinary,
    writeImageData = iauStorage.writeBinary;
export { fetchBinary, fetchImageData, writeBinary, writeImageData };
var deleteNote = notes.deleteNote,
    fetchNote = notes.fetchNote,
    writeNote = notes.writeNote;
export { deleteNote, fetchNote, writeNote };
var fetchFromStorage = storage.fetchFromStorage,
    fetchFromStorageByPrefix = storage.fetchFromStorageByPrefix,
    saveToStorage = storage.saveToStorage,
    batchSaveToStorage = storage.batchSaveToStorage; // this is intended to math the API from 'storage' just above for backwards compatibility reasons

export { fetchFromStorage, fetchFromStorageByPrefix, saveToStorage, batchSaveToStorage };
var fetchFromMathStorage = mathStorage.getItem,
    fetchFromMathStorageByPrefix = mathStorage.getAll,
    saveToMathStorage = mathStorage.postItem,
    batchSaveToMathStorage = mathStorage.batchPost;
export { fetchFromMathStorage, fetchFromMathStorageByPrefix, saveToMathStorage, batchSaveToMathStorage };
var fetchSharedStorageByUserAndPrefix = sharedStorage.fetchSharedStorageByUserAndPrefix,
    fetchUserSharedStorage = sharedStorage.fetchUserSharedStorage,
    listSharedStorageByPrefix = sharedStorage.listSharedStorageByPrefix,
    saveToSharedStorage = sharedStorage.saveToSharedStorage;
export { fetchSharedStorageByUserAndPrefix, fetchUserSharedStorage, listSharedStorageByPrefix, saveToSharedStorage };
var createAssignment = assignmentService.createAssignment,
    deleteAssignment = assignmentService.deleteAssignment,
    fetchClassAssignments = assignmentService.fetchClassAssignments,
    fetchUserAssignments = assignmentService.fetchUserAssignments,
    getAssignment = assignmentService.getAssignment,
    updateAssignment = assignmentService.updateAssignment,
    updateReadContentStatuses = assignmentService.updateReadContentStatuses;
export { createAssignment, deleteAssignment, fetchClassAssignments, fetchUserAssignments, getAssignment, updateAssignment, updateReadContentStatuses };
var cancelSyncJob = gradeSync.cancelSyncJob,
    getAllSyncsForUser = gradeSync.getAllSyncsForUser,
    getGradeSyncStatus = gradeSync.getGradeSyncStatus,
    getGradeSyncVersion = gradeSync.getGradeSyncVersion,
    getSyncJob = gradeSync.getSyncJob,
    pingGradeSync = gradeSync.pingGradeSync,
    postNewSync = gradeSync.postNewSync;
export { cancelSyncJob, getAllSyncsForUser, getGradeSyncStatus, getGradeSyncVersion, getSyncJob, pingGradeSync, postNewSync };
var checkUserGrantAuthStatus = lmsMappingService.checkUserGrantAuthStatus,
    followAuthorizeUrl = lmsMappingService.followAuthorizeUrl,
    getLmsMappingServiceStatus = lmsMappingService.getLmsMappingServiceStatus,
    getLmsMappingServiceVersion = lmsMappingService.getLmsMappingServiceVersion,
    getUserContexts = lmsMappingService.getUserContexts,
    pingLmsMappingService = lmsMappingService.pingLmsMappingService,
    resetUserSchoologyGrants = lmsMappingService.resetUserSchoologyGrants;
export { checkUserGrantAuthStatus, followAuthorizeUrl, getLmsMappingServiceStatus, getLmsMappingServiceVersion, getUserContexts, pingLmsMappingService, resetUserSchoologyGrants };
var deleteObject = object.deleteObject,
    deleteObjectByFileName = object.deleteObjectByFileName,
    fetchObject = object.fetchObject,
    fetchObjectByFileName = object.fetchObjectByFileName,
    sendObject = object.sendObject;
export { deleteObject, deleteObjectByFileName, fetchObject, fetchObjectByFileName, sendObject };
var copyGoogleSlidesPresentation = slidesService.copyGoogleSlidesPresentation,
    getGoogleAuthSlidesStatus = slidesService.getGoogleAuthSlidesStatus,
    resetGoogleAuthSlidesStatus = slidesService.resetGoogleAuthSlidesStatus;
export { copyGoogleSlidesPresentation, getGoogleAuthSlidesStatus, resetGoogleAuthSlidesStatus };
var CUSTOM_CONTENT_FACETS = customContentService.CUSTOM_CONTENT_FACETS,
    CUSTOM_CONTENT_STATUSES = customContentService.CUSTOM_CONTENT_STATUSES,
    createCustomContent = customContentService.createCustomContent,
    fetchCustomContent = customContentService.fetchCustomContent,
    fetchCustomContentByAdvancedSearch = customContentService.fetchCustomContentByAdvancedSearch,
    fetchCustomContentBySearch = customContentService.fetchCustomContentBySearch,
    fetchCustomContentItemBySearch = customContentService.fetchCustomContentItemBySearch,
    getCustomContentForLesson = customContentService.getCustomContentForLesson,
    getDownloadUrl = customContentService.getDownloadUrl,
    getUploadUrl = customContentService.getUploadUrl,
    hasPublishedCustomContent = customContentService.hasPublishedCustomContent,
    hasCustomContent = customContentService.hasCustomContent,
    markContentStatus = customContentService.markContentStatus,
    removeCustomContentFacetValue = customContentService.removeCustomContentFacetValue,
    setCustomContentFacetValue = customContentService.setCustomContentFacetValue,
    updateCustomContent = customContentService.updateCustomContent;
export { CUSTOM_CONTENT_FACETS, CUSTOM_CONTENT_STATUSES, createCustomContent, fetchCustomContent, fetchCustomContentByAdvancedSearch, fetchCustomContentBySearch, fetchCustomContentItemBySearch, getCustomContentForLesson, getDownloadUrl, getUploadUrl, hasPublishedCustomContent, hasCustomContent, markContentStatus, removeCustomContentFacetValue, setCustomContentFacetValue, updateCustomContent };
export default {
  fetchIntercomUserHash: thirdPartySecrets.fetchIntercomUserHash,
  fetchLearnositySignature: thirdPartySecrets.fetchLearnositySignature,
  fetchQuillHash: thirdPartySecrets.fetchQuillHash,
  fetchWorkSummary: portfolio.fetchWorkSummary,
  fetchUsersWithWork: portfolio.fetchUsersWithWork,
  fetchClassSummary: portfolio.fetchClassSummary,
  clearWork: portfolio.clearWork,
  updateFeedbackInsight: portfolio.updateFeedbackInsight,
  fetchCardstacksForUnit: content.fetchCardstacksForUnit,
  fetchUnit: content.fetchUnit,
  fetchOverview: content.fetchOverview,
  fetchUnitRevision: content.fetchUnitRevision,
  fetchUnitRevisionAliases: content.fetchUnitRevisionAliases,
  checkUnitKeysAreValid: content.checkUnitKeysAreValid,
  fetchScores: score.fetchScores,
  fetchScoresForCardstacks: score.fetchScoresForCardstacks,
  saveScores: score.saveScores,
  fetchSubmissions: submission.fetchSubmissions,
  fetchMySubmissions: submission.fetchMySubmissions,
  fetchRecentSubmissions: submission.fetchRecentSubmissions,
  fetchSubmissionBreadcrumbs: submission.fetchSubmissionBreadcrumbs,
  postSubmissions: submission.postSubmissions,
  forceSubmissions: submission.forceSubmissions,
  fetchSubmissionForActivity: submission.fetchSubmissionForActivity,
  fetchManualScore: feedback.fetchManualScore,
  fetchAllManualScores: feedback.fetchAllManualScores,
  fetchLatestManualScore: feedback.fetchLatestManualScore,
  saveManualScore: feedback.saveManualScore,
  saveAllManualScores: feedback.saveAllManualScores,
  saveAndSendManualScore: feedback.saveAndSendManualScore,
  sendManualScore: feedback.sendManualScore,
  markManualScoreAsRead: feedback.markManualScoreAsRead,
  markAllManualScoresAsRead: feedback.markAllManualScoresAsRead,
  fetchAllCommentsInCardstack: feedback.fetchAllCommentsInCardstack,
  deleteComment: feedback.deleteComment,
  updateComment: feedback.updateComment,
  createComment: feedback.createComment,
  saveAllComments: feedback.saveAllComments,
  markCommentAsRead: feedback.markCommentAsRead,
  markAllCommentsAsRead: feedback.markAllCommentsAsRead,
  markAllFeedbackAsRead: feedback.markAllFeedbackAsRead,
  sendComments: feedback.sendComments,
  saveAndSendAllComments: feedback.saveAndSendAllComments,
  sendScoreAndComments: feedback.sendScoreAndComments,
  getSkills: feedback.getSkills,
  fetchUnsentFeedbackCountForCardstack: feedback.fetchUnsentFeedbackCountForCardstack,
  fetchUnsentFeedbackCountForClass: feedback.fetchUnsentFeedbackCountForClass,
  submitAllFeedbackForCardstack: feedback.submitAllFeedbackForCardstack,
  fetchAllUnreadFeedback: feedback.fetchAllUnreadFeedback,
  saveRubricScore: feedback.saveRubricScore,
  saveAllRubricScores: feedback.saveAllRubricScores,
  fetchRubricScores: feedback.fetchRubricScores,
  setAutoScoreVisibility: feedback.setAutoScoreVisibility,
  deleteSubmissionsAndAutosaves: resetSubmissions.deleteSubmissionsAndAutosaves,
  fetchAutosave: autosave.fetchAutosave,
  fetchAutosavesByPrefix: autosave.fetchAutosavesByPrefix,
  fetchBulkAutosaves: autosave.fetchBulkAutosaves,
  writeAutosave: autosave.writeAutosave,
  autosaveExists: autosave.autosaveExists,
  fetchWorkSummaryStatus: workSummary.fetchWorkSummaryStatus,
  fetchBulkWorkSummaryStatus: workSummary.fetchBulkWorkSummaryStatus,
  fetchWorksheet: worksheet.fetchWorksheet,
  fetchBulkWorksheets: worksheet.fetchBulkWorksheets,
  writeWorksheet: worksheet.writeWorksheet,
  deleteWorksheets: worksheet.deleteWorksheets,
  deleteWorksheet: worksheet.deleteWorksheet,
  fetchClientStateBatch: clientState.fetchClientStateBatch,
  saveClientStateToStorage: clientState.saveStateToStorage,
  fetchClientStateFromStorage: clientState.fetchStateFromStorage,
  fetchClientState: clientState.fetchClientState,
  saveClientState: clientState.saveClientState,
  deleteClientState: clientState.deleteClientState,
  saveLastStartedClass: clientState.saveLastStartedClass,
  saveLastLessonViewedLocation: clientState.saveLastLessonViewedLocation,
  fetchLanguageState: clientState.fetchLanguageState,
  saveLanguageState: clientState.saveLanguageState,
  fetchLastLessonLocation: clientState.fetchLastLessonLocation,
  fetchLastLessonViewedLocation: clientState.fetchLastLessonViewedLocation,
  fetchClassworkState: clientState.fetchClassworkState,
  saveClassworkState: clientState.saveClassworkState,
  fetchClassContentState: clientState.fetchClassContentState,
  saveClassContentState: clientState.saveClassContentState,
  saveAllClassContentStates: clientState.saveAllClassContentStates,
  fetchStudentState: clientState.fetchStudentState,
  saveStudentState: clientState.saveStudentState,
  fetchCustomComments: clientState.fetchCustomComments,
  saveCustomComments: clientState.saveCustomComments,
  saveGoogleDocId: clientState.saveGoogleDocId,
  fetchGoogleDocId: clientState.fetchGoogleDocId,
  saveStudentAudioAccessState: clientState.saveStudentAudioAccessState,
  saveAllStudentAudioAccessStates: clientState.saveAllStudentAudioAccessStates,
  fetchStudentAudioAccessState: clientState.fetchStudentAudioAccessState,
  fetchAllStudentAudioAccessStates: clientState.fetchAllStudentAudioAccessStates,
  deleteGoogleDocId: clientState.deleteGoogleDocId,
  fetchUserFile: clientState.fetchUserFile,
  saveUserFile: clientState.saveUserFile,
  saveOptInStatusForUser: clientState.saveOptInStatusForUser,
  fetchOptInStatusForUser: clientState.fetchOptInStatusForUser,
  deleteOptInStatusForUser: clientState.deleteOptInStatusForUser,
  fetchViewedTutorials: clientState.fetchViewedTutorials,
  saveViewedTutorials: clientState.saveViewedTutorials,
  saveSelectedCustomLesson: clientState.saveSelectedCustomLesson,
  fetchSelectedCustomLesson: clientState.fetchSelectedCustomLesson,
  fetchClassroomSettingState: clientState.fetchClassroomSettingState,
  controllerEnum: clientState.controllerEnum,
  saveClassroomSettingState: clientState.saveClassroomSettingState,
  fetchAllClassroomSettingStates: clientState.fetchAllClassroomSettingStates,
  saveAllClassroomSettingStates: clientState.saveAllClassroomSettingStates,
  getStates: contentAccess.getStates,
  getRosterAccessState: contentAccess.getRosterAccessState,
  getStudentAccessState: contentAccess.getStudentAccessState,
  lockStudent: contentAccess.lockStudent,
  unlockStudent: contentAccess.unlockStudent,
  lockStudentAudio: contentAccess.lockStudentAudio,
  unlockStudentAudio: contentAccess.unlockStudentAudio,
  fetchStudentVariants: studentVariant.fetchStudentVariants,
  fetchStudentVariantsBatch: studentVariant.fetchStudentVariantsBatch,
  saveStudentVariants: studentVariant.saveStudentVariants,
  fetchAmpConfig: ampConfig.fetchAmpConfig.bind(ampConfig),
  fetchClass: onboarding.fetchClass,
  fetchClassRoster: onboarding.fetchClassRoster,
  fetchUserClasses: onboarding.fetchUserClasses,
  fetchUser: onboarding.fetchUser,
  setUniqueDisplayNames: onboarding.setUniqueDisplayNames,
  filterActiveStudents: utility.filterActiveStudents,
  sortStudents: utility.sortStudents,
  onlyClasses: utility.onlyClasses,
  fetchDrmAssessmentActivityMarks: drm.fetchDrmAssessmentActivityMarks,
  fetchDrmAssessmentActivityAudio: drm.fetchDrmAssessmentActivityAudio,
  fetchDrmPublicKey: drm.fetchPublicKey,
  fetchDrmGlobalKey: drm.fetchGlobalKey,
  fetchDrmUserKey: drm.fetchUserKey,
  fetchDrmSettings: drm.fetchSettings,
  fetchDrmChecksum: drm.fetchChecksum,
  fetchDrmDeviceUpdates: drm.fetchDeviceUpdates,
  pingDrm: drm.ping,
  fetchDrmBooks: drm.fetchBooks,
  fetchDrmBookDetails: drm.fetchBookDetails,
  acquireDrmBookLicense: drm.acquireBookLicense,
  revokeDrmBookLicense: drm.revokeBookLicense,
  fetchDrmBookComponent: drm.fetchBookComponent,
  fetchDrmBookResource: drm.fetchBookResource,
  fetchDrmBookChecksum: drm.fetchBookChecksum,
  searchDrmBook: drm.searchBook,
  fetchProgramData: retail.fetchProgramData,
  fetchProgramDataWithHeaders: retail.fetchProgramDataWithHeaders,
  fetchUserAssets: retail.fetchUserAssets,
  fetchEntitlementsFromClasses: retail.fetchEntitlementsFromClasses,
  fetchAllMyClassesWithPrograms: retail.fetchAllMyClassesWithPrograms,
  fetchAllMyStudentsAssets: retail.fetchAllMyStudentsAssets,
  fetchAllMyClassAssets: retail.fetchAllMyClassAssets,
  createInsights: insights.createInsights,
  fetchInsight: insights.fetchInsight,
  fetchAllInsights: insights.fetchAllInsights,
  updateInsight: insights.updateInsight,
  updateInsightStudent: insights.updateInsightStudent,
  createOrUpdateInsight: userCreatedInsights.createOrUpdateInsight,
  findInsight: userCreatedInsights.findInsight,
  dismissInsight: userCreatedInsights.dismissInsight,
  fetchClassroomState: classroomState.fetchClassroomState,
  saveClassroomState: classroomState.saveClassroomState,
  batchFetchClassroomState: classroomState.batchFetchClassroomState,
  batchSaveClassroomState: classroomState.batchSaveClassroomState,
  fetchClassroomStateWithPrefix: classroomState.fetchClassroomStateWithPrefix,
  deleteAllClassroomStateWithPrefix: classroomState.deleteAllClassroomStateWithPrefix,
  config: {
    set: configService.set,
    get: configService.get
  },
  fetchBinary: iauStorage.fetchBinary,
  writeBinary: iauStorage.writeBinary,
  fetchImageData: iauStorage.fetchBinary,
  writeImageData: iauStorage.writeBinary,
  fetchNote: notes.fetchNote,
  writeNote: notes.writeNote,
  deleteNote: notes.deleteNote,
  batchSaveToStorage: storage.batchSaveToStorage,
  fetchFromStorageByPrefix: storage.fetchFromStorageByPrefix,
  fetchFromStorage: storage.fetchFromStorage,
  saveToStorage: storage.saveToStorage,
  fetchUserSharedStorage: sharedStorage.fetchUserSharedStorage,
  saveToSharedStorage: sharedStorage.saveToSharedStorage,
  listSharedStorageByPrefix: sharedStorage.listSharedStorageByPrefix,
  fetchSharedStorageByUserAndPrefix: sharedStorage.fetchSharedStorageByUserAndPrefix,
  createAssignment: assignmentService.createAssignment,
  fetchUserAssignments: assignmentService.fetchUserAssignments,
  deleteAssignment: assignmentService.deleteAssignment,
  fetchClassAssignments: assignmentService.fetchClassAssignments,
  getAssignment: assignmentService.getAssignment,
  updateAssignment: assignmentService.updateAssignment,
  updateReadContentStatuses: assignmentService.updateReadContentStatuses,
  updateHandedInContentStatuses: assignmentService.updateHandedInContentStatuses,
  pingGradeSync: gradeSync.pingGradeSync,
  getGradeSyncStatus: gradeSync.getGradeSyncStatus,
  getGradeSyncVersion: gradeSync.getGradeSyncVersion,
  postNewSync: gradeSync.postNewSync,
  cancelSyncJob: gradeSync.cancelSyncJob,
  getSyncJob: gradeSync.getSyncJob,
  getAllSyncsForUser: gradeSync.getAllSyncsForUser,
  pingLmsMappingService: lmsMappingService.pingLmsMappingService,
  getLmsMappingServiceStatus: lmsMappingService.getLmsMappingServiceStatus,
  getLmsMappingServiceVersion: lmsMappingService.getLmsMappingServiceVersion,
  getUserContexts: lmsMappingService.getUserContexts,
  sendObject: object.sendObject,
  fetchObjectByFileName: object.fetchObjectByFileName,
  fetchObject: object.fetchObject,
  deleteObject: object.deleteObject,
  deleteObjectByFileName: object.deleteObjectByFileName,
  checkUserGrantAuthStatus: lmsMappingService.checkUserGrantAuthStatus,
  followAuthorizeUrl: lmsMappingService.followAuthorizeUrl,
  resetUserSchoologyGrants: lmsMappingService.resetUserSchoologyGrants,
  copyGoogleSlidesPresentation: slidesService.copyGoogleSlidesPresentation,
  getGoogleAuthSlidesStatus: slidesService.getGoogleAuthSlidesStatus,
  resetGoogleAuthSlidesStatus: slidesService.resetGoogleAuthSlidesStatus,
  createCustomContent: customContentService.createCustomContent,
  fetchCustomContent: customContentService.fetchCustomContent,
  fetchCustomContentByAdvancedSearch: customContentService.fetchCustomContentByAdvancedSearch,
  fetchCustomContentBySearch: customContentService.fetchCustomContentBySearch,
  fetchCustomContentItemBySearch: customContentService.fetchCustomContentItemBySearch,
  getCustomContentForLesson: customContentService.getCustomContentForLesson,
  getDownloadUrl: customContentService.getDownloadUrl,
  getUploadUrl: customContentService.getUploadUrl,
  hasPublishedCustomContent: customContentService.hasPublishedCustomContent,
  hasCustomContent: customContentService.hasCustomContent,
  markContentStatus: customContentService.markContentStatus,
  removeCustomContentFacetValue: customContentService.removeCustomContentFacetValue,
  setCustomContentFacetValue: customContentService.setCustomContentFacetValue,
  updateCustomContent: customContentService.updateCustomContent,
  CUSTOM_CONTENT_FACETS: customContentService.CUSTOM_CONTENT_FACETS,
  CUSTOM_CONTENT_STATUSES: customContentService.CUSTOM_CONTENT_STATUSES,
  // math-storage endpoints
  fetchFromMathStorage: mathStorage.getItem,
  fetchFromMathStorageByPrefix: mathStorage.getAll,
  saveToMathStorage: mathStorage.postItem,
  batchSaveToMathStorage: mathStorage.batchPost
};